import { doc, writeBatch } from "firebase/firestore";

// Firestore's own hard limit on operations in a single batch/transaction.
const FIRESTORE_BATCH_LIMIT = 500;

function chunk(array, size) {
  const out = [];
  for (let i = 0; i < array.length; i += size) {
    out.push(array.slice(i, i + size));
  }
  return out;
}

/**
 * Marks the given `notifications` document ids as read using Firestore
 * batched writes (chunked to stay under Firestore's 500-operation batch
 * limit), instead of one individual network round-trip per document.
 *
 * Chunks are committed sequentially, not in parallel - in production a
 * single user's unread count will essentially always fit in one chunk, so
 * this is one batch commit; sequential commits only matter for the
 * theoretical >500-unread case, where parallel commits would offer no
 * benefit and add contention risk for no reason.
 */
export async function markNotificationsReadBatched(db, ids) {
  const uniqueIds = Array.from(
    new Set(
      (ids || [])
        .filter((id) => typeof id === "string")
        .map((id) => id.trim())
        .filter((id) => id.length > 0)
    )
  );
  if (!uniqueIds.length) return;

  for (const idsChunk of chunk(uniqueIds, FIRESTORE_BATCH_LIMIT)) {
    const batch = writeBatch(db);
    for (const id of idsChunk) {
      batch.update(doc(db, "notifications", id), { read: true });
    }
    await batch.commit();
  }
}
